export enum ModificationEmployeeState {
IsPending,
Accepted,
Cancelled,
}
